<template>
  <div class="terms-container">
    <span class="campaign-tag">#SmokeAlarmsSaveLives 2026</span>
    <h1>#PressTEST Challenge: Terms and Conditions</h1>
    <p>
      These terms and conditions apply to the #PressTEST challenge giveaway run
      on the Facebook and Instagram channels of the #SmokeAlarmsSaveLives 2026
      campaign. By taking part, participants accept these terms.
    </p>

    <h2>1. Organiser</h2>
    <p>
      The giveaway is organised by the European Fire Safety Alliance (EuroFSA)
      as part of the European Smoke Alarm Day campaign #SmokeAlarmsSaveLives
      2026 (the &ldquo;Organiser&rdquo;).
    </p>
    <p>
      Questions about the giveaway can be sent by private message to the
      campaign's official Facebook or Instagram account.
    </p>

    <h2>2. Platform disclaimer</h2>
    <p>
      This giveaway is in no way sponsored, endorsed or administered by, or
      associated with, Meta Platforms, Facebook or Instagram. Participants
      provide their information to the Organiser, not to Meta. Each participant
      releases Meta from any liability in connection with the giveaway.
    </p>

    <h2>3. Who can take part</h2>
    <ul>
      <li>
        Participants must be 18 years or older and resident in a Member State
        of the European Union.
      </li>
      <li>
        Employees of the Organiser, of the campaign coordinators and
        supporters, and their immediate families, may not win a prize.
      </li>
      <li>
        Participants need a public or accessible Facebook or Instagram account
        so that their entry can be seen.
      </li>
      <li>
        Each person may win only one prize. Entries from multiple or fake
        accounts will be disqualified.
      </li>
    </ul>

    <h2>4. How the challenge works</h2>
    <ul>
      <li>
        Entry period: from Sunday 25 October 2026, 00:00 until Friday 20
        November 2026, 23:59 (Brussels time).
      </li>
      <li>
        How to enter: test your smoke alarm by pressing its TEST button, then
        (a) comment &ldquo;TESTED &#9989;&rdquo; on a #PressTEST post on
        Facebook or Instagram (a photo is welcome but not required), or (b)
        share an Instagram Story showing your test and tag the campaign
        account, or (c) send the campaign account a photo of your test by
        private message.
      </li>
      <li>
        Each person counts as one entry in the draw, however many times they
        take part.
      </li>
      <li>
        Safety: do not climb on chairs or unstable furniture to test an alarm.
        Use a broom handle or a stable step-ladder. Entries that show unsafe
        behaviour may be excluded.
      </li>
    </ul>

    <h2>5. Prizes</h2>
    <ul>
      <li>
        5 smoke alarms, one per winner. All smoke alarms conform to the
        European standard EN 14604.
      </li>
      <li>
        Prizes are as described and cannot be exchanged for cash or other
        items. The Organiser may replace a prize with one of equal or greater
        value if it becomes unavailable.
      </li>
      <li>
        Prizes are sent free of charge to an address in the European Union.
        The Organiser is not responsible for delays caused by postal services.
      </li>
    </ul>

    <h2>6. Random draw</h2>
    <p>
      5 winners are drawn at random on Monday 23 November 2026 by the
      Organiser, using a random selection tool, from all entries that meet
      these terms. Entries that are incomplete, posted outside the entry
      period, offensive, or that break these terms or the platform rules are
      not valid.
    </p>

    <h2>7. Winners</h2>
    <ul>
      <li>
        Winners are announced on the campaign's Facebook and Instagram pages
        by first name or account name, only with their consent.
      </li>
      <li>
        Winners are contacted by private message from the official campaign
        account only. Winners must reply within 7 days with the delivery
        details requested. If a winner does not reply in time, a new winner is
        drawn.
      </li>
      <li>
        Beware of fake accounts. The Organiser will never ask winners for
        payment, card or bank details, passwords, or to click on a link to
        claim a prize.
      </li>
    </ul>

    <h2>8. Photos and content</h2>
    <ul>
      <li>
        By sharing a photo or comment, participants confirm that it is their
        own and that anyone shown in it has agreed to appear in it (a parent
        or guardian must agree for anyone under 18).
      </li>
      <li>
        Participants agree that the Organiser may reshare their entry on the
        campaign channels, with credit, for the duration of the campaign.
        Participants can ask for their content to be removed at any time by
        private message.
      </li>
    </ul>

    <h2>9. Personal data</h2>
    <ul>
      <li>
        The Organiser is responsible for personal data collected in the
        giveaway.
      </li>
      <li>
        Winners' names and postal addresses are used only to send the prize
        and to announce the winners (with consent). They are not shared with
        third parties except the delivery service, and are deleted within 30
        days after the prize has been delivered.
      </li>
      <li>
        Participants may ask to access, correct or delete their data at any
        time by private message to the campaign account. Participants also
        have the right to lodge a complaint with their national data
        protection authority.
      </li>
    </ul>

    <h2>10. Other terms</h2>
    <ul>
      <li>
        The Organiser may exclude participants who break these terms, act
        dishonestly or try to manipulate the giveaway.
      </li>
      <li>
        If the giveaway cannot run as planned for reasons beyond the
        Organiser's control, the Organiser may change, suspend or end it, and
        will announce this on the campaign channels.
      </li>
      <li>
        Nothing in these terms limits participants' statutory consumer rights.
      </li>
      <li>
        These terms are available in English. If any provision is found
        invalid, the remaining provisions remain in force.
      </li>
    </ul>

    <p class="terms-footer">
      European Fire Safety Alliance (EuroFSA) &middot; #SmokeAlarmsSaveLives
      2026
    </p>
  </div>
</template>

<script>
export default {
  name: "ChallengeTermsConditions",
  metaInfo: {
    title: "#PressTEST Challenge: Terms and Conditions",
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables";

.terms-container {
  min-height: 100vh;
  color: #1e1826;
  padding: 200px calc(min(160px, 10vw)) 60px;
  font-family: $mainFont;

  .campaign-tag {
    font-family: $semiBoldFont;
    color: $mainColor;
    font-size: 20px;
  }

  h1 {
    font-family: $semiBoldFont;
    font-size: clamp(28px, 3.5vw, 40px);
    margin: 10px 0 30px;
  }

  h2 {
    font-family: $semiBoldFont;
    font-size: 24px;
    margin: 40px 0 12px;
  }

  p,
  li {
    font-size: 18px;
    line-height: 28px;
  }

  ul {
    padding-left: 24px;

    li {
      margin: 8px 0;
    }
  }

  .terms-footer {
    margin-top: 50px;
    font-family: $semiBoldFont;
  }
}
</style>
